import { Directive, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { DefaultService } from '../default-service';
import { ListaResultset } from '../../list/lista-resultset.interface';
import { ErrorHandlerService } from '../error-handler.service';

type FnBuscarItem    = (filter: any) => Observable<ListaResultset<any>>;

@Directive()
export class MyAutocomplete<T> implements OnDestroy {

  resultset: T[];
  resultsetMaxSize: number;
  itemSelecionado: T;
  itemService: DefaultService<T>;
  private itemSubject: Subject<T> = null;
  private resultSetSubject: Subject<ListaResultset<T>> = null;

  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    private url: string,
    private fnBuscarItem?: FnBuscarItem,
    private filter?: any,
    private autoBuscarItemPorCampo?: string,
    private selecionarPrimeiroResultado?: boolean,
    private fnEventQuery?: Function
  ) {
    this.resultset   = [];

    if ( url ) {
      this.itemService = new DefaultService<T>(httpClient, errorHandlerService, url);
    }
    this.resultsetMaxSize = environment.localizador_max_size;

    if ( this.selecionarPrimeiroResultado ) {
      this.buscarItem(this.filter);
    }
  }

  ngOnDestroy() {
    this.destroy();
  }

  public destroy(): void {
    if ( this.itemSubject ) {
      this.itemSubject.unsubscribe();
      this.itemSubject = null;
    }

    if ( this.resultSetSubject ) {
      this.resultSetSubject.unsubscribe();
      this.resultSetSubject = null;
    }
  }

  buscarItemObservable(pFilter: any): Observable<ListaResultset<any>> {
    if ( this.fnBuscarItem ) {
      try {
        return this.fnBuscarItem(pFilter);
      }
      catch (e) {
        console.error('Verifique seu método de buscarItem');
        console.error(e);
      }
    }
    else if ( this.itemService ) {
      if ( this.autoBuscarItemPorCampo ) {
        if ( (pFilter.query === undefined || pFilter.query === null) && this.fnEventQuery ) {
          this.filter[this.autoBuscarItemPorCampo] = this.fnEventQuery( pFilter );
        }
        else {
          this.filter[this.autoBuscarItemPorCampo] = pFilter.query;
        }
      }

      return this.itemService
                 .listar(this.filter)
                 .pipe(
                    map((result: ListaResultset<T>) => {
                      if ( this.resultSetSubject ) {
                        this.resultSetSubject.next(result);
                      }
                      return result;
                    })
                 );
    }
  }

  public getItemSubject(): Subject<T> {
    if ( !this.itemSubject ) {
      this.itemSubject = new Subject<T>();
    }

    return this.itemSubject;
  }

  public getResultSetSubject(): Subject<ListaResultset<T>> {
    if ( !this.resultSetSubject ) {
      this.resultSetSubject = new Subject<ListaResultset<T>>();
    }

    return this.resultSetSubject;
  }

  public getResultset(): T[] {
    return this.resultset;
  }

  public buscarItem(pFilter: any): void {
    this.buscarItemObservable(pFilter)
        .subscribe((response: ListaResultset<T>) => {
          this.resultset = response.content;

          if ( this.selecionarPrimeiroResultado ) {
            this.selecionarPrimeiroResultado = false;

            if ( this.resultset && this.resultset.length > 0 ) {
              this.itemSelecionado = this.resultset[0];

              if ( this.itemSubject ) {
                this.itemSubject.next(this.itemSelecionado);
              }
            }
          }
        });
  }

  public selecionarItem(itemASelecionar: T): void {
    this.onSelectItem(itemASelecionar);
  }

  onSelectItem(itemSelecionado: T): void {
    this.itemSelecionado = itemSelecionado;

    if ( this.itemSubject ) {
      this.itemSubject.next(this.itemSelecionado);
    }
  }

  onClearItem(): void {
    this.itemSelecionado = null;

    if ( this.itemSubject ) {
      this.itemSubject.next(null);
    }
  }

  clear(): void {
    this.onClearItem();
  }

  onFocus($event: any): void {
  }

}
